import { tokens } from '@cub-com-br/theme/tokens';
import { colors } from '~/theme';

export const DESKTOP_BREAKPOINT = '(min-width: 900px)';
export const CONTENT_MAX_WIDTH = 1200;
export const SIDE_PANEL_WIDTH = 360;
export const SIDE_PANEL_GAP = 3;
export const SIDE_PANEL_GAP_PX = SIDE_PANEL_GAP * 8;
export const MAIN_CONTENT_WIDTH = CONTENT_MAX_WIDTH - SIDE_PANEL_WIDTH - SIDE_PANEL_GAP_PX;
export const NAVBAR_HEIGHT = 56;
export const MOBILE_BOTTOM_GAP = 22;

export const containerSx = {
  backgroundColor: colors.white,
  border: `1px solid ${tokens.grey300}`,
  borderRadius: '8px',
};
